export default __webpack_public_path__ + "static/media/northcarolina.f94b3fd8.jpg";